import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class LeadCommunicationService {
  private emailCommunicationList = new BehaviorSubject<any[]>([]);
  private callCommunicationList = new BehaviorSubject<any[]>([]);
  emailCommunication$ = this.emailCommunicationList.asObservable();
  callCommunication$ = this.callCommunicationList.asObservable();

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setCommunicationData(emailData: any, callData: any) {
    this.emailCommunicationList.next(emailData);
    this.callCommunicationList.next(callData);
  }

  addEmailData(newEmail: any) {
    let newEmailObj: any = {
      name: this.localStorage.getProfileName(),
      date: moment(newEmail.date_of_communication).format('DD/MM/YYYY HH:mm'),
      desc: `Subject: ${newEmail.email_extra_details.subject} - Note: ${newEmail.note}`,
      id: newEmail.id,
      restData: newEmail
    };
    this.emailCommunicationList.next([...this.emailCommunicationList.value, newEmailObj]);
  }

  addCallData(newCall: any) {
    let newCallObj: any = {
      name: this.localStorage.getProfileName(),
      date: moment(newCall.date_of_communication).format('DD/MM/YYYY HH:mm'),
      desc: `Status: ${newCall.status} - Call Duration: ${newCall.call_extra_details.callDuration} sec - Note: ${newCall.note}`,
      id: newCall.id,
      restData: newCall
    };
    this.callCommunicationList.next([newCallObj, ...this.callCommunicationList.value]);
  }

}
